<template>
    <span>
        {{ title }}
    </span>
</template>

<script>
    const R = require('ramda')

    const type = (finalityId, id, name, alternatives = []) => {
        return {
            finalityId,
            id,
            name,
            alternatives
        }
    }

    const subtype = (id, name) => {
        return {
            id,
            name
        }
    }

    const titles = [
        // Rural
        type(4, 10, 'Loteamento Rural'),
        type(4, 11, 'Terreno Rural'),
        // Comercial
        type(2, 17, 'Área Comercial'),
        type(2, 18, 'Armazem/Barracão Comercial'),
        type(2, 8, 'Casa Comercial', [
            subtype(11, 'Sobreposta Alta Comercial'),
            subtype(12, 'Sobreposta Baixa Comercial'),
            subtype(13, 'Edícula Comercial'),
            subtype(14, 'Casa Térrea Comercial'),
            subtype(15, 'Casa Comercial Duplex'),
            subtype(16, 'Casa Comercial Triplex')
        ]),
        type(2, 36, (_, __, subtype) => subtype.name),
        type(2, 22, 'Galpão Industrial(Finalidade Comercial)', [
            subtype(17, 'Galpão Comercial(Finalidade Comercial)'),
            subtype(18, 'Galpão Logístico(Finalidade Comercial)'),
            subtype(19, 'Galpão Industrial(Finalidade Comercial)')
        ]),
        type(2, 25, 'Loja Comercial'),
        type(2, 10, 'Loteamento Comercial'),
        type(2, 30, 'Prédio Comercial'),
        type(2, 23, 'Sala Comercial'),
        type(2, 24, 'Salão Comercial'),
        type(2, 9, 'Sobrado Comercial'),
        type(2, 33, 'Sobreloja Comercial'),
        type(2, 11, 'Terreno Comercial'),
        // Industrial
        type(3, 17, 'Área Industrial'),
        type(3, 18, 'Armazem/Barracão Industrial'),
        type(3, 10, 'Loteamento Industrial'),
        type(3, 30, 'Prédio Industrial'),
        type(3, 11, 'Terreno Industrial'),
        type(3, 22, 'Galpão Industrial(Finalidade Industrial)', [
            subtype(17, 'Galpão Comercial(Finalidade Industrial)'),
            subtype(18, 'Galpão Logístico(Finalidade Industrial)'),
            subtype(19, 'Galpão Industrial(Finalidade Industrial)')
        ]),
        // Residencial
        type(1, 1, 'Apartamento', [
            subtype(1, 'Apartamento 1 por andar'),
            subtype(2, 'Apartamento Duplex'),
            subtype(3, 'Apartamento Garden'),
            subtype(4, 'Apartamento Garden Elevado'),
            subtype(6, 'Apartamento Térreo'),
            subtype(7, 'Apartamento Triplex')
        ]),
        type(1, 17, 'Área Residencial'),
        type(1, 8, 'Casa', [
            subtype(11, 'Sobreposta Alta'),
            subtype(12, 'Sobreposta Baixa'),
            subtype(13, 'Casa Edícula'),
            subtype(14, 'Casa Térrea'),
            subtype(15, 'Casa Duplex'),
            subtype(16, 'Casa Triplex')
        ]),
        type(1, 38, 'Casa de Condomínio', [
            subtype(139, 'Sobreposta Alta de Condomínio'),
            subtype(140, 'Sobreposta Baixa de Condomínio'),
            subtype(141, 'Edícula de Condomínio'),
            subtype(142, 'Casa Térrea de Condomínio'),
            subtype(143, 'Casa Duplex de Condomínio'),
            subtype(144, 'Casa Triplex de Condomínio')
        ]),
        type(1, 2, 'Cobertura', [
            subtype(8, 'Cobertura Duplex'),
            subtype(9, 'Cobertura Triplex')
        ]),
        type(1, 10, 'Loteamento Residencial'),
        type(1, 11, 'Terreno Residencial')
    ]

    // <editor-fold defaultstate="collapsed">
    const oldTitles = {
        rural: {
            'chácara': {
                default: 'Chácara'
            },
            'fazenda': {
                default: 'Fazenda'
            },
            'Haras': {
                default: 'Haras'
            },
            'Loteamento': {
                default: 'Loteamento Rural'
            },
            'rancho': {
                default: 'Rancho'
            },
            'sítio': {
                default: 'Sítio'
            },
            'terreno': {
                default: 'Terreno Rural'
            }

        },
        comercial: {
            'área': {
                default: 'Área comercial'
            },
            'armazem/barracão': {
                default: 'Armazem/Barracão Comercial'
            },
            casa: {
                default: 'Casa Comercial',
                duplex: 'Casa Comercial Duplex',
                'edícula': 'Edícula Comercial',
                'Sobreposta Alta': 'Sobreposta Alta Comercial',
                'Sobreposta Baixa': 'Sobreposta Baixa Comercial',
                'Térrea': 'Casa Térrea Comercial',
                triplex: 'Casa Comercial Triplex'
            },
            'conjunto comercial': {
                default: 'Conjunto Comercial'
            },
            'fundo de comércio': {
                default: (subtype) => subtype.name
            },
            'galeria': {
                default: 'Galeria'
            },
            'galpão': {
                default: 'Galpão Industrial(Finalidade Comercial)',
                'galpão comercial': 'Galpão Comercial(Finalidade Comercial)',
                'galpão industrial': 'Galpão Industrial(Finalidade Comercial)',
                'galpão logísticulo': 'Galpão Logísticulo(Finalidade Comercial)'
            },
            'laje corporativa': {
                default: 'Laje Corporativa'
            },
            'loja': {
                default: 'Loja Comercial'
            },
            'loteamento': {
                default: 'Loteamento Comercial'
            },
            'prédio': {
                default: 'Prédio Comercial'
            },
            'sala': {
                default: 'Sala Comercial'
            },
            'salão': {
                default: 'Salão Comercial'
            },
            'sobrado': {
                default: 'Sobrado Comercial'
            },
            'sobreloja': {
                default: 'Sobreloja Comercial'
            },
            'terreno': {
                default: 'Terreno Comercial'
            }

        },
        industrial: {
            'área': {
                default: 'Área Industrial'
            },
            'armazem/barracão': {
                default: 'Armazem/Barracão Industrial'
            },
            'conjunto industrial': {
                default: 'Conjunto Industrial'
            },
            'indústria': {
                default: 'indústria'
            },
            'jazidas': {
                default: 'jazidas'
            },
            'loteamento': {
                default: 'Loteamento Industrial'
            },
            'mineradora': {
                default: 'Mineradora'
            },
            'pch': {
                default: 'PCH'
            },
            'pedreira': {
                default: 'Pedreira'
            },
            'prédio': {
                default: 'Prédio industrial'
            },
            'terreno': {
                default: 'Terreno Industrial'
            },
            'uhe': {
                default: 'UHE'
            },
            'Usina': {
                default: 'Usina'
            },
            'galpão': {
                default: 'Galpão Industrial(Finalidade Industrial)',
                'galpão comercial': 'Galpão Comercial(Finalidade Industrial)',
                'galpão industrial': 'Galpão Industrial(Finalidade Industrial)',
                'galpão logísticulo': 'Galpão Logísticulo(Finalidade Industrial)'
            }
        },
        residencial: {
            'apartamento': {
                default: 'Apartamento',
                '1 por andar': 'Apartamento 1 por andar',
                'duplex': 'Apartamento Duplex',
                'garden': 'Apartamento Garden',
                'garden elevado': 'Apartamento Garden Elevado',
                'térreo': 'Apartamento Térreo',
                'triples': 'Apartamento Triplex'
            },
            'área': {
                default: 'Área residencial'
            },
            'casa': {
                default: 'Casa',
                duplex: 'Casa Duplex',
                'edícula': 'Casa Edícula',
                'Sobreposta Alta': 'Sobreposta Alta',
                'Sobreposta Baixa': 'Sobreposta Baixa',
                'Térrea': 'Casa Térrea',
                triplex: 'Casa Triplex'
            },
            'casa de condomínio': {
                default: 'Casa de condomínio',
                duplex: 'Casa de condomínio Duplex',
                'edícula': 'Edícula de condomínio',
                'Sobreposta Alta': 'Sobreposta Alta de condomínio',
                'Sobreposta Baixa': 'Sobreposta Baixa de condomínio',
                'Térrea': 'Casa Térrea de condomínio',
                triplex: 'Casa Triplex de condomínio'
            },
            cobertura: {
                default: 'Cobertura',
                'cobertura duplex': 'Cobertura Duplex',
                'cobertura triplex': 'Cobertura Triplex'
            },
            flat: {
                default: 'flat'
            },
            kitnet: {
                default: 'kitnet'
            },
            loft: {
                default: 'loft'
            },
            loteamento: {
                default: 'Loteamento Residencial'
            },
            penthouse: {
                default: 'Penthouse'
            },
            'sala living': {
                default: 'Sala Living'
            },
            sobrado: {
                default: 'Sobrado'
            },
            'sobrado de condomínio': {
                default: 'Sobrado de Condomínio'
            },
            terreno: {
                default: 'Terreno Resicencial'
            },
            'terreno de condomínio': {
                default: 'Terreno de condomínio'
            }
        }
    }
    // </editor-fold>

    export default {
        props: {
            property: {
                default: () => ({}),
                Type: Object
            }
        },
        name: 'property-title',
        computed: {
            title () {
                const finalityId = this.property.finality
                const type = this.property.typeInfo
                const typeId = this.property.type
                const subtype = this.property.subtypeInfo
                const subtypeId = this.property.subtype

                const firstTitle = titles.find(_ => _.finalityId === finalityId && _.id === typeId)

                if (!firstTitle && type && !subtype) {
                    return type.name
                } else if (!firstTitle) {
                    return this.defaultTitle
                }

                const secondTitle = firstTitle.alternatives.find(_ => _.id === subtypeId)

                let title = firstTitle.name
                if (secondTitle) {
                    title = secondTitle.name
                }

                if (typeof title === 'function') {
                    return title(this.property.finalityInfo, this.property.typeInfo, this.property.subtypeInfo)
                }

                return title
            },
            defaultTitle () {
                const finality = R.propOr('-', 'name', this.property.finalityInfo)
                const type = R.propOr('-', 'name', this.property.typeInfo)
                const subtype = R.propOr('-', 'name', this.property.subtypeInfo)

                return `Finalidade: ${finality} Tipo: ${type} Subtipo: ${subtype}`
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Title.vue?3b321eb0